<script setup>
defineProps({
  stroke: {
    type: String,
    default: "#8C8C8C",
  },
  width: {
    type: Number,
    default: 8,
  },
  height: {
    type: Number,
    default: 6,
  },
});
</script>
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1.5L4 4.5L1 1.5"
      :stroke="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
